/**
 * The name a person knows each table by, for the key the table saves its Show/Hide columns choice
 * under (#2788). Settings lists the saved choices by these names (#6151).
 *
 * A key is the app's own, such as `fee-schedule-categories`, and means nothing to a reader. A table
 * that starts to save its choice adds its key here; `table-titles.spec.ts` fails until it does.
 */
const tableTitles: ReadonlyMap<string, string> = new Map([
  ["communications", "Communications"],
  ["document-collection", "Selected documents"],
  ["documents", "Documents"],
  ["fee-schedule-categories", "Fee schedule categories"],
  ["fee-schedules", "Fee schedules"],
  ["forums", "Communications: Conversations"],
  ["marketplace-bookmarks-companies", "Bookmarks: Company"],
  ["marketplace-bookmarks-individuals", "Bookmarks: Individual"],
  ["marketplace-bookmarks-teams", "Bookmarks: Team"],
  ["marketplace-profiles", "Your profiles"],
  ["permissions-additional", "Permissions: Additional permissions"],
  ["permissions-matrix", "Permissions: Matrix"],
  ["proposals", "Proposals"],
  ["super-user-invitations", "Invitations"],
  ["teams-active", "Teams"],
  ["teams-templates", "Teams: Templates"],
  ["users", "Users"],
  ["work-agreements", "Work"],
]);

/**
 * What a person reads for a table this version of the app does not know: one removed or renamed
 * since the choice was saved. Its key means nothing to a reader, but the choice can still be reset.
 */
export const UNKNOWN_TABLE_TITLE = "A table no longer in Attorney Hub";

/** The table's name, or `UNKNOWN_TABLE_TITLE` when this version of the app does not know the table. */
export function tableTitle(tableKey: string): string {
  return tableTitles.get(tableKey) ?? UNKNOWN_TABLE_TITLE;
}
